import React from 'react';
import { useTranslation } from 'react-i18next';
import { HiLockClosed, HiShieldExclamation, HiShieldCheck, HiExclamationTriangle, HiClipboardDocumentList } from 'react-icons/hi2';
import SectionTitle from '../components/SectionTitle';
import InfoBox from '../components/InfoBox';
import TabGroup, { TabPanel } from '../components/TabGroup';

const Detention = () => {
  const { t } = useTranslation();

  return (
    <div className="space-y-8">
      <SectionTitle level={1} icon={HiLockClosed}>
        {t('detention.title')}
      </SectionTitle>

      <TabGroup>
        {/* TAB 1: VOS DROITS */}
        <TabPanel tabId="rights">
          <section>
            <SectionTitle level={2} icon={HiShieldCheck}>
              {t('detention.rightsTitle')}
            </SectionTitle>
            <div className="bg-teal-50 dark:bg-teal-900/20 border-l-4 border-teal-600 dark:border-teal-400 p-4 rounded-r-lg">
              <ul className="space-y-3">
                {t('detention.rightsItems', { returnObjects: true }).map((item, index) => (
                  <li key={index} className="flex items-start">
                    <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1 font-bold">✓</span>
                    <span className="text-gray-900 dark:text-white font-medium">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </section>

          <section>
            <SectionTitle level={2} icon={HiShieldExclamation}>
              {t('detention.healthRightsTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('detention.healthRightsItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section>
            <SectionTitle level={2} icon={HiClipboardDocumentList}>
              {t('detention.contactRightsTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('detention.contactRightsItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>
        </TabPanel>

        {/* TAB 2: DÉMARCHES */}
        <TabPanel tabId="procedures">
          <section>
            <SectionTitle level={2} icon={HiClipboardDocumentList}>
              {t('detention.proceduresTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('detention.proceduresItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section>
            <SectionTitle level={2} icon={HiShieldExclamation}>
              {t('detention.detentionTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('detention.detentionItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>
        </TabPanel>

        {/* TAB 3: SI PROBLÈME */}
        <TabPanel tabId="problems">
          <InfoBox type="important" title={t('home.needHelpTitle')}>
            <p>{t('home.needHelpContent')}</p>
          </InfoBox>

          <section>
            <SectionTitle level={2} icon={HiExclamationTriangle}>
              {t('detention.problemsTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('detention.problemsItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-orange-600 dark:text-orange-400 mr-2 mt-1">!</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <InfoBox type="danger" title={t('detention.urgentTitle')}>
            <p>{t('detention.urgentContent')}</p>
          </InfoBox>
        </TabPanel>
      </TabGroup>
    </div>
  );
};

export default Detention;
